import {Link} from '@primer/react'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useLayoutRouteData} from '../../../page-data/loaders/use-layout-route-data'
import styles from './PreviewStackDialog.module.css'

export type PreviewStackDescriptionProps = {
  isExtendingExistingStack: boolean
  existingStackNumber?: number | null
  hasOtherNewlyAddedPulls: boolean
}

export function PreviewStackDescription({
  isExtendingExistingStack,
  existingStackNumber,
  hasOtherNewlyAddedPulls,
}: PreviewStackDescriptionProps) {
  const {repository} = useLayoutRouteData()
  if (isExtendingExistingStack && existingStackNumber != null) {
    return (
      <p className={styles.description}>
        {`This pull request${hasOtherNewlyAddedPulls ? ' and other pull requests' : ''} can be added to `}
        <span>
          {isFeatureEnabled('pull_requests_stacks_view_ui') ? (
            <Link inline href={`/${repository.ownerLogin}/${repository.name}/stack/${existingStackNumber}`}>
              stack #{existingStackNumber}
            </Link>
          ) : (
            `stack #${existingStackNumber}`
          )}
        </span>
        . Review and update the stack when you’re ready.
      </p>
    )
  }

  return (
    <p className={styles.description}>
      This pull request can be stacked with other pull requests. Review and create the stack when you’re ready.
    </p>
  )
}
